// Customers liste sayfası için saf yardımcılar — React yok, I/O yok.

/**
 * GET /Customer/List için query string üretir.
 * Boş alanlar (search/companyid/storeid) eklenmez; repeat yalnızca true iken
 * eklenir; değerler URL-encode edilir.
 */
export const buildListQuery = ({
  pageNumber = 1,
  pageSize = 10,
  sortBy = 'lastorder',
  sortOrder = 'desc',
  search = '',
  repeat = false,
  companyid = '',
  storeid = '',
} = {}) => {
  const params = new URLSearchParams();
  params.set('pageNumber', String(pageNumber));
  params.set('pageSize', String(pageSize));
  params.set('sortBy', sortBy);
  params.set('sortOrder', sortOrder);
  const trimmed = (search || '').trim();
  if (trimmed) params.set('search', trimmed);
  if (repeat) params.set('repeat', 'true');
  if (companyid) params.set('companyid', companyid);
  if (storeid) params.set('storeid', storeid);
  return `?${params.toString()}`;
};

/**
 * GET /Customer/Counts için query string üretir. Counts ucu yalnızca
 * companyid/storeid'i dikkate alır; ikisi de boşsa boş string döner.
 */
export const buildCountsQuery = ({ companyid = '', storeid = '' } = {}) => {
  const params = new URLSearchParams();
  if (companyid) params.set('companyid', companyid);
  if (storeid) params.set('storeid', storeid);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

/**
 * Mevcut sıralama ve tıklanan kolon anahtarına göre bir sonraki sıralamayı döner.
 * Aynı kolon → yön ters çevrilir. Farklı kolon → o kolon, varsayılan yönüyle
 * (name artan, diğerleri azalan).
 */
export const nextSort = (currentSort, key) => {
  if (currentSort.sortBy === key) {
    return {
      sortBy: key,
      sortOrder: currentSort.sortOrder === 'asc' ? 'desc' : 'asc',
    };
  }
  return { sortBy: key, sortOrder: key === 'name' ? 'asc' : 'desc' };
};
